import { LoyaltyPointsReturnRefundEventSchema } from "@redotech/redo-customer-event-common/customer-event-zod-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getLoyaltyRefundEventForReturn = {
  name: "getLoyaltyRefundEventForReturn" as const,
  input: z.object({ customerId: zExt.objectId(), returnId: zExt.objectId() }),
  output: z.object({ event: LoyaltyPointsReturnRefundEventSchema.nullable() }),
};
